export type ReviewActions = {
	/** "Close review" as the secondary action; on the last question it is the primary one. */
	closeFirst: boolean
	previous: boolean
	primary: 'next' | 'close'
}

/** What the trainer can do from the question the review is on. */
export const reviewActions = (
	currentQuestionIndex: number,
	questionCount: number
): ReviewActions => {
	const last = currentQuestionIndex >= questionCount - 1
	return {
		closeFirst: !last,
		previous: currentQuestionIndex > 0,
		primary: last ? 'close' : 'next',
	}
}
